import React from 'react'

export default function Faoliyat() {
  return (
    <div>Faoliyat</div>
  )
}
